import { render } from "./Branch.vue?vue&type=template&id=7c42a480&scoped=true"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"

import "./Branch.vue?vue&type=style&index=0&id=7c42a480&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7c42a480"

export default script